import { render, staticRenderFns } from "./_siteList.vue?vue&type=template&id=0236c983&lang=pug"
import script from "./_siteList.vue?vue&type=script&lang=js"
export * from "./_siteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports